export const PageHeader = ({ eyebrow, title, sub, children }) => (
  <div className="flex flex-wrap items-end justify-between gap-4 mb-10 fade-up">
    <div>
      <div className="eyebrow mb-3">{eyebrow}</div>
      <h1 className="font-serif text-4xl sm:text-5xl text-[var(--ink)] leading-[1.05]">{title}</h1>
      {sub && <p className="mt-3 text-sm sm:text-base text-white/50 max-w-xl">{sub}</p>}
    </div>
    {children}
  </div>
);
